import api from '@/services/api'

export default {

  namespaced: true,

  state: {
    opened: false,
    formData: {}
  },

  mutations: {
    reset (state) {
      state.formData = {}
    },

    updateField (state, { key, value }) {
      state.formData[key] = value
    }
  },

  actions: {
    async send ({ state }, action) {
      const data = state.formData;

      const response = await api.form.send(data)
      return response
    }
  }

}




// WEBPACK FOOTER //
// ./src/store/modules/form.js